import type { FC } from "react";

import { router } from "../bootstrap/router.ts";

import { Accounts } from "./Accounts.tsx";
import { AuthCallback } from "./AuthCallback.tsx";
import { Dashboard } from "./Dashboard.tsx";
import { Maintenance } from "./Maintenance.tsx";
import { Metrics } from "./Metrics.tsx";
import { OAuthConsent } from "./OAuthConsent.tsx";
import { Playground } from "./Playground.tsx";
import { Signin } from "./Signin.tsx";
import { Tables } from "./Tables.tsx";

type RouteTag = "nav" | "unauthenticated";

interface Route {
  readonly Component: FC;
  readonly label: string;
  readonly path: string;
  readonly tags?: readonly RouteTag[];
}

const routes: readonly Route[] = [
  {
    Component: Dashboard,
    label: "Dashboard",
    path: router.getPattern("Dashboard"),
    tags: ["nav"],
  },
  {
    Component: Accounts,
    label: "Accounts",
    path: router.getPattern("Accounts"),
    tags: ["nav"],
  },
  {
    Component: Tables,
    label: "Tables",
    path: router.getPattern("Tables"),
    tags: ["nav"],
  },
  {
    Component: Metrics,
    label: "Metrics",
    path: router.getPattern("Metrics"),
    tags: ["nav"],
  },
  {
    Component: Playground,
    label: "Playground",
    path: router.getPattern("Playground"),
    tags: ["nav"],
  },
  {
    Component: Maintenance,
    label: "Maintenance",
    path: router.getPattern("Maintenance"),
    tags: ["nav"],
  },
  {
    Component: OAuthConsent,
    label: "Authorize",
    path: router.getPattern("OAuthConsent"),
  },
  {
    Component: Signin,
    label: "Signin",
    path: router.getPattern("Signin"),
    tags: ["unauthenticated"],
  },
  {
    Component: AuthCallback,
    label: "Auth",
    path: router.getPattern("AuthCallback"),
    tags: ["unauthenticated"],
  },
];

export const navRoutes = routes.filter(isNav);

export const authenticatedRoutes = routes.filter(isAuthenticated);

export const unauthenticatedRoutes = routes.filter(isUnauthenticated);

function isAuthenticated(route: Route): boolean {
  return !isUnauthenticated(route);
}

function isNav(route: Route): boolean {
  return route.tags?.includes("nav") ?? false;
}

function isUnauthenticated(route: Route): boolean {
  return route.tags?.includes("unauthenticated") ?? false;
}
